// @mui material components
import Card from "@mui/material/Card";



import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { login } from './../../../api/routes';
import { useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { toast } from "react-toastify";

function Basic() {
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [loading, setLoading] = useState(false);
  const handleOpenLoading = () => {
    setLoading(true);
  };
  const handleCloseLoading = () => {
    setLoading(false);
  };

  const submit = () => {
    if (password && username) {
      const data = {
        username: username,
        password: password,
      }
      handleOpenLoading()
      login(data, (isOk, data) => {
        if (!isOk) {
          handleCloseLoading()
          toast.error(data.message);
        }
        else {
          sessionStorage.setItem('x-auth-token', data.token);
          window.location.replace('/dashboard');
        }
      })
    }
  }
  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            ورود
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput type="username" value={username} onChange={(event) => setUsername(event.target.value)} label="نام کاربری" fullWidth />
            </MDBox>
            <MDBox mb={2}>
              <MDInput type="password" value={password} onChange={(event) => setPassword(event.target.value)} label="رمز عبور" fullWidth />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth onClick={submit}>
                ورود
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </BasicLayout>
  );
}

export default Basic;
